import { useMemo } from 'react';

import {
  useIsConversationInsightsV2Enabled,
  useIsInsightsCampaignEnabled,
  useIsInsightsLeadersMyInsightsNavigationEnabled,
  useIsInsightsLeadersOrgNavigationEnabled,
  useIsInsightsQnAMyInsightsEnabled,
  useIsInsightsQnAOrgEnabled,
  useIsQuestionsOnlyMode,
  useIsVivaInsightsAudienceThemeCardEnabled,
  useIsVivaInsightsNetworkEnabled,
} from '../../featureChecks';
import { UseMainUIFeatureSettings } from '../../types';

export const useInsightsNavigationSettings: UseMainUIFeatureSettings<'insightsNavigation'> = (options) => {
  const insightsNavigationOverrides = options?.overrides?.insightsNavigation;

  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  const audienceThemeCard = useIsVivaInsightsAudienceThemeCardEnabled();
  const campaign = useIsInsightsCampaignEnabled();
  const conversationInsightsV2 = useIsConversationInsightsV2Enabled();
  const leadersMyInsights = useIsInsightsLeadersMyInsightsNavigationEnabled();
  const leadersOrg = useIsInsightsLeadersOrgNavigationEnabled();
  const network = useIsVivaInsightsNetworkEnabled();
  const qnaMyInsights = useIsInsightsQnAMyInsightsEnabled();
  const qnaOrg = useIsInsightsQnAOrgEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        audienceThemeCard: false,
        campaign: false,
        conversationInsightsV2: false,
        leadersMyInsights: false,
        leadersOrg: false,
        network: false,
        qnaMyInsights,
        qnaOrg,
        ...insightsNavigationOverrides,
      };
    }

    return {
      audienceThemeCard,
      campaign,
      conversationInsightsV2,
      leadersMyInsights,
      leadersOrg,
      network,
      qnaMyInsights,
      qnaOrg,
      ...insightsNavigationOverrides,
    };
  }, [
    audienceThemeCard,
    campaign,
    conversationInsightsV2,
    insightsNavigationOverrides,
    isQuestionsOnlyMode,
    leadersMyInsights,
    leadersOrg,
    network,
    qnaMyInsights,
    qnaOrg,
  ]);
};
